import ErrorLine from 'components/ErrorLine'
import { listSongsAndVideo } from 'controllers/SocialServiceController'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CATEGORY_MODES } from 'redux/reducers/harmonizeReducer'
import { buildAndSetPlaylist } from 'util/fetchUtils'
//import { getMediaVideo, getMediaAudio,getVideoSrc } from 'util/imageUtils'
//import { getAudioUrl, getVideoUrl} from 'util/playlistUtils'
//import { isNewFormat } from 'util/postUtils'
import { displayError } from 'util/screenUtils'
import DisplayHarmonizePost from 'vortex/DisplayHarmonizePost'

export default function GoogleBotPage() {
    const { currentRoom, playList } = useSelector(state => state.messages)
    const [error, setError] = useState()
    const dispatch = useDispatch()
    const displayPost = (msg) => {
        return (
            <DisplayHarmonizePost
                key={msg._id}
                content={msg}
                room={currentRoom}
                displayTitle={true}
            />
        )
    }
    /*
    const getActualMediaSrc = (message) => {
        const videoSrc = getVideoSrc(message)
        if (videoSrc) {
            const { source, name } = getMediaVideo(message.media)
            return getVideoUrl(source, name)
        } else {
            const { source, name } = getMediaAudio(message.media)
            return getAudioUrl(source, name, !isNewFormat(message))
        }
    }

    const getVideoHtml = (url, title, description, createdAt, publishedAt) => {

        return `
                {
                "@context": "https://schema.org/",
                "@type": "VideoObject",
                "name": "${title}",
                "description": "${description ? description : title}",
                "contentUrl": "${url}",
                "thumbnailUrl":"https://harmonize.social/harmonize-lp.jpg",
                "uploadDate":"${publishedAt ? publishedAt : createdAt}"
                }`
    }
    */
    /** Currently not used because what this does is expose endpoints that are
     * blocked by CORS and we don't want to open those up to Google search yet if ever.
     * 
     * @todo Solve delivery of video
     * AudioObjects are not used by Google. The parser is very finicky (at least when
     * testing the URL in Webmaster tools) so don't e.g. have any trailing commas.
     
    const buildStructuredData = (songs) => {
        const script = document.createElement('script')
        script.type = 'application/ld+json'
        script.innerHTML = '['
        let ix = 0
        const filteredSongs = songs.filter(ft => CATEGORY_MODES.VIDEO.categories.includes(ft.category))
        filteredSongs.forEach(msg => {
            const { name, message, media, createdAt, publishedAt } = msg
            const title = name.replaceAll('"', '\\"')
            const description = message.replaceAll('"', '\\"')
            const song = { ...msg, entryMedia: media }
            const url = getActualMediaSrc(song)
            script.innerHTML += getVideoHtml(url, title, description, createdAt, publishedAt)
            ix++
            if (ix < filteredSongs.length) {
                script.innerHTML += ','
            }
        }
        )
        //You need to do this to the ] or you get an Invalid value error from Google
        script.innerHTML += '\n]\n'
        console.log(`structuredData ${ix} items`, script)
        document.head.appendChild(script)
    }
    */
    /**
     * For Google to see the structured data, it must be output before the page is rendered.
     * So we get the media, then build the structure data, then update the playList so that
     * the page is rendered.
     */
    useEffect(() => {
        const getAndBuild = async () => {
            try {
                const songs = await listSongsAndVideo(CATEGORY_MODES.ALL_MEDIA, 0, 70)
                //buildStructuredData(songs)
                buildAndSetPlaylist(songs, CATEGORY_MODES.ALL_MEDIA, dispatch)
            } catch (error) {
                displayError(error, setError)
            }
        }
        console.log(`GooglebotPage useEffect load messages`)
        getAndBuild()

    }, [])

    if (playList.length || error) {
        return (
            <div>
                <ErrorLine error={error} />
                {playList.map((m => displayPost(m)))}
            </div>
        )
    } else {
        return null
    }
}